import React, { useState } from 'react';
import { Search, ShoppingCart } from 'lucide-react';
import { Input } from './ui/input';

const Header = ({ onSearch, cartCount, onCartClick }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    onSearch(value);
  };

  return (
    <header className="sticky top-0 z-50 bg-white border-b shadow-sm">
      <div className="max-w-7xl mx-auto px-3 py-3">
        {/* Linha 1: Logo e Carrinho */}
        <div className="flex items-center justify-between">
          <div className="flex-shrink-0">
            <img
              src="/logo-margareth-black.png"
              alt="Margareth Bernardo"
              className="h-9 md:h-11 cursor-pointer object-contain"
              onClick={() => window.location.href = '/'}
              data-testid="site-logo"
            />
          </div>

          {/* Busca no desktop - junto com logo */}
          <div className="hidden sm:flex items-center gap-3 flex-1 max-w-md ml-4">
            <div className="relative flex-1">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
              <Input
                type="text"
                placeholder="Buscar perfumes..."
                value={searchTerm}
                onChange={handleSearch}
                className="pl-10"
                data-testid="search-input-desktop"
              />
            </div>
          </div>

          <button
            onClick={onCartClick}
            className="relative p-2 hover:bg-gray-100 rounded-full transition-colors ml-2"
            data-testid="cart-button"
          >
            <ShoppingCart className="w-6 h-6" />
            {cartCount > 0 && (
              <span 
                className="absolute -top-1 -right-1 bg-black text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold"
                data-testid="cart-count"
              >
                {cartCount}
              </span>
            )}
          </button>
        </div>

        {/* Linha 2: Busca no mobile - abaixo da logo */}
        <div className="sm:hidden mt-2">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
            <Input
              type="text"
              placeholder="Buscar perfumes..."
              value={searchTerm}
              onChange={handleSearch}
              className="pl-10 h-9 text-sm"
              data-testid="search-input-mobile"
            />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
